import { createRouter, createWebHistory } from 'vue-router'
import storageRoutes from './components/storage/routes'
import eventRoutes from './components/events/routes'
import materialRoutes from './components/materials/routes'
import adminRoutes from './components/admin/routes'

export default createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: { name: 'events' } },
    ...storageRoutes,
    ...eventRoutes,
    ...materialRoutes,
    ...adminRoutes,
  ]
})
